import React from 'react';
import cn from 'classnames';
import CTAS from 'react-scale/components/elements/cta/buttons';
import Form from 'react-scale/components/elements/simple-form';
import FormBanner from 'react-scale/components/elements/simple-form-banner';
import ModalForm from 'react-scale/components/elements/button/hubspot-modal';

const CTA = ({ theme, cta, themeColors, center, size, fullWidth }) => (
  <>
    <div
      className={cn(
        'flex',
        fullWidth ? 'w-full' : 'w-auto',
        { 'items-center': center },
        { 'flex-wrap justify-center gap-6 lg:justify-start': cta.hubspotModal && cta.buttons }
      )}
    >
      {cta.buttons?.length > 0 && (
        <div className={cn(fullWidth ? 'w-full' : 'w-auto')}>
          <CTAS
            theme={theme}
            ctas={cta.buttons}
            size={size}
            themeColors={themeColors}
            fullWidth={fullWidth}
          />
        </div>
      )}
      {cta.hubspotModal && cta.hubspotModal.formId !== '' && (
        <div className={fullWidth ? 'w-full' : 'w-auto'}>
          <ModalForm
            theme={theme}
            formId={cta.hubspotModal.formId}
            label={cta.hubspotModal.label}
            themeColors={cta.hubspotModal.buttons}
            type={cta.hubspotModal.type}
            variant={cta.hubspotModal.variant}
            size={size}
            fullWidth={fullWidth}
            title={cta.hubspotModal?.title ?? cta.hubspotModal.label}
          />
        </div>
      )}
      {cta.hubspotForm && (
        <div className={cn('w-full', { 'm-auto': center })}>
          <Form form={cta.hubspotForm} theme={theme} duplicateId={cta.hubspotForm.duplicateId} />
        </div>
      )}
      {cta.hubspotFormBanner && (
        <div className={cn('w-full', { 'm-auto': center })}>
          <FormBanner
            form={cta.hubspotFormBanner}
            theme={theme}
            duplicateId={cta.hubspotFormBanner.duplicateId}
          />
        </div>
      )}
    </div>
    {cta.disclaimer && <p className="mt-4 text-sm italic text-neutral-300">{cta.disclaimer}</p>}
  </>
);

CTA.defaultProps = {
  theme: 'dark',
  center: true,
  fullWidth: false,
  cta: {
    hubspotForm: false,
    hubspotModal: false,
    hubspotFormBanner: false,
    buttons: [
      {
        text: 'Get Started',
        href: '/rapid',
        type: 'primary',
        variant: 'default'
      },
      {
        text: 'Book a Demo',
        href: '/sales'
      }
    ]
  },
  disclaimer: false
};

export default CTA;
